exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#hero.gleam-promo .ql-editor .ql-size-large {\n  font-size: 20px;\n}\n.section-mini-bar div h3 p {\n  margin: 0 !important;\n}", ""]);

// exports
